import React, { useState } from 'react';
import styles from './index.module.scss'
import { Container, Row, Col } from 'react-bootstrap';
import Facebook from '../../../assets/svg/facebook';
import Twitter from '../../../assets/svg/twitter';
import Instagram from '../../../assets/svg/instagram';
import Youtube from '../../../assets/svg/youtube';
import AngleDown from '../../../assets/svg/AngleDown';
import PDF from './../../../assets/pdf/Composition-of-the-CSR-Committee.pdf'
import LogoXl from '../../../images/logo-xl.png'

const Header = (props) => {
  // const {compData} = props;
  const [navbar, setNavbar] = useState(false);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const handleClick = () => {
    setNavbar(!navbar);
  };

  return (
    <header className={styles.headerWrapper}>
        <Container>
            <nav>
                <Row>
                    <Col className={'gx-lg-0 position-relative'} lg={2}>
                        <a href="/" className={styles.logoWrapper}>
                            <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
                        </a>
                        <button className={`${styles.navBarToggler} ${navbar ? styles.navbarActive : ''}`} type="button" onClick={handleClick}>
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </Col>
                    <Col lg={10}>
                        <div className={`${styles.menuWrapper} ${navbar ? styles.active : ''}`}>
                          {isMobile && <img src={LogoXl} loading="lazy" className={styles.menuBg} alt="Statue of Belief"/>}
                        <div className={styles.collapseMenuTopbar}>
                        <ul className="navbar-nav mr-auto">
                                  <li className="nav-item item-btn">
                                      <a className="nav-link" href="https://booking.statueofbelief.com/" rel="noreferrer">Book Ticket</a>
                                  </li>
                                  {/* <li className="nav-item item-btn">
                                      <a className="nav-link" href="https://booking.statueofbelief.com/" target='_blank'>Login</a>
                                  </li> */}
                                  {/* <li className="nav-item item-btn-dark">
                                    <a className="nav-link" href="#">Partner Login</a>
                                </li> */}
                                  {/* <li className="nav-item">
                                      <a className="nav-link" href="#">Corporate &amp; Schools</a>
                                  </li>
                                  <li className="nav-item">
                                      <a className="nav-link" href="#">Offers</a>
                                  </li> */}
                                  <li className="nav-item">
                                      <a className="nav-link" href="/places-to-visit-near-nathdwara">Nearby Places</a>
                                  </li>
                                  <li className="nav-item">
                                      <a className="nav-link" href="/csr">CSR</a>
                                  </li>
                                  {/* <li className="nav-item">
                                      <a className="nav-link" href="/how-to-reach-statue-of-belief">How to Reach SOB</a>
                                  </li> */}
                                  <li className="nav-item">
                                    <a className="nav-link" href="https://www.facebook.com/statue.of.belief.official/" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Facebook /></span></a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="https://twitter.com/statueofbelief" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Twitter /></span></a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="https://www.instagram.com/statue.of.belief/" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Instagram /></span></a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="https://www.youtube.com/@statueofbeliefoffical" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Youtube /></span></a>
                          </li>
                              </ul>
                        </div>
                        <div className={styles.collapseMenu}>
                        <ul className="navbar-nav mr-auto">
                                <li className="nav-item active">
                                  <a className="nav-link" href="/about-us">About Us</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="/events">Events</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="/media">Media</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="/attractions">Attractions</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="https://booking.statueofbelief.com/">Tickets &amp; Offers</a>
                                </li>
                                <li className="nav-item nav-item-dropdown">
                                  <a className="nav-link">Investors <span><AngleDown /></span></a>
                                  <ul className='nav-dropdown'>
                                    <li><a href={PDF} target='_blank' download>CSR Committee</a></li>
                                    <li><a href="/extract-of-annual-return">Extract of Annual Return(s)</a></li>
                                    <li><a href="/annual-return">Annual Return(s)</a></li>
                                    <li><a href="/notice-of-general-meeting">Notice of General Meeting(s)</a></li>
                                    <li><a href="/notice-of-resignation-of-directors">Notice of Resignation of Director(s)</a></li>
                                    <li><a href="/notice-of-candidature-of-a-person-for-directorship">Notice of candidature of a person for Directorship</a></li>
                                    <li><a href="/publication-of-name-by-company">Publication of name by Company</a></li>
                                  </ul>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" href="/contact-us">Contact Us</a>
                                </li>
                                
                              </ul>
                        </div>
                        <div className={styles.collapseMenuMobile}>
                        <ul className="navbar-nav mr-auto">
                                <li className="nav-item active">
                                  <a className="nav-link" href="https://booking.statueofbelief.com/" rel="noreferrer">Book Ticket</a>
                                </li>
                                <li className="nav-item">
                                      <a className="nav-link" href="/places-to-visit-near-nathdwara">Nearby Places</a>
                                </li>
                                <li className="nav-item">
                                      <a className="nav-link" href="/csr">CSR</a>
                                </li>
                                {/*   <li className="nav-item">
                                      <a className="nav-link" href="/how-to-reach-statue-of-belief">How to Reach SOB</a>
                                  </li> */}
                              </ul>
                        </div>
                        <div className={styles.socialIconsWrapper}>
                            <ul>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.facebook.com/statue.of.belief.official/" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Facebook /></span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://twitter.com/statueofbelief" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Twitter /></span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.instagram.com/statue.of.belief" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Instagram /></span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.youtube.com/@statueofbeliefoffical" target='_blank' rel="noreferrer"><span className={styles.socialIcons}><Youtube /></span></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </Col>
                </Row>
            </nav>
        </Container>
    </header>
  );
};

export default Header;
